<template>
    <div class="container mt-5" style="height:500px">
        <!-- Modal loader start  -->
        <div class="text-xs-center">
            <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">Votre demande est en cours de traitement</span>
    </div>

            <!-- <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
                <v-card color="orange" dark>
                    <v-card-text>
                        Votre demande est en cours de traitement
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog> -->

            <v-dialog v-model="comeFromPayLink" hide-overlay persistent width="450">
                <v-card color="info" dark height="100">
                    <v-card-text>
                        <span>
                            Votre demande a été pris en compte. Vous serez rappelé d'ici peu
                        </span>
                    </v-card-text>
                </v-card>
            </v-dialog>

        </div>
    </div>
</template>

<script>
import Api from "../services/Api";
import axios from 'axios'
import store from '../store/store'
import Delivery from '../services/Delivery'
import PushInDataLayer from '../services/TagManager';

export default {
    name: 'orabankrep',

    data() {
        return {
            elevation: 2,
            Mano: null,
            dialogLoading: false,
            Contrat_provisoire: null,
            TheBranche: null,
            brancheName: null,
            ThePartner: null,
            numDevis: null,
            proprio: null,
            comeFromPayLink: false,
            ToastTabSucess: { // Customized options for success toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "success",
                className: "custom-success-class"
            },
            ToastTabError: { // Customized options for error toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "error"
            },
        }
    },
    created() {
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 1000)
    },

    beforeDestroy() {
        localStorage.removeItem('Recurrentpayment')
    },

    methods: {
        isMobile: function () {
            if (screen.width <= 760) {
                return true
            } else {
                return false
            }
        },

        BlockPaymentLink() {
            let id = localStorage.getItem('PaymentlinkId');
            if (typeof id !== 'undefined' && typeof id == 'string') {
                Api().post('paymentLink/block/link', {
                    id: id
                })
                    .then(response => {
                        localStorage.setItem('BlockedLink', JSON.stringify(response.data))
                    })
            }
        },

        isDesktop: function () {
            if (screen.width > 760) {
                return true
            } else {
                return false
            }
        },

        purchasePushin() {
            if (this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined') {
                try {
                    let purchasePushin = JSON.parse(localStorage.getItem('purchasePushin'))
                    purchasePushin.ecommerce.transaction_id = (this.$store.state.devispayement.devis.numeroDevis).replace(/[/]/g, '_');
                    PushInDataLayer(purchasePushin)
                } catch (error) {
                    console.log(error)
                }
            }
        },

        payement_end: function (params) {
            this.purchasePushin()
            Api().post('contrat/attestation/retrait', { 
                numero: params.numeroDevis,
                dateEffet: params.dateEffet,
                dateEcheance: params.dateEcheance
            })
                .then(response => {
                    if (response.data.count >= 1) {
                        if (localStorage.getItem('adressliv') !== '') {
                            Delivery(this.$store.state.devispayement.devis)
                        }
                        this.BlockPaymentLink();
                        this.sendmailAdmin();
                        this.$store.dispatch('setNewcontrat', response.data.contrats[0]);
                        this.$store.dispatch('setDevisPayement', null);
                        this.$router.push('/contrat/ok');
                    } else {
                        this.$router.push('/payement/failed')
                    }
                })
                .catch(e => {
                    this.$router.push('/payement/failed')
                })
        },

        async fetchEventsList() {
            console.log("Fetch Event", this.Mano)
            this.Mano = this.Mano - 1
            let contratchecker = await this.checkContrat(this.$store.state.devispayement.devis)
            if (contratchecker.data.contrats.length >= 1) {
                clearInterval(this.timer);
                this.CheckOrabRes()
            } else if (this.Mano == 0) {
                clearInterval(this.timer);
                this.CheckOrabRes()
            }
        },

        async checkContrat(params) {
            return await Api().post('contrat/attestation/retrait', { numero: params.numeroDevis })
        },

        CheckOrabRes: function () {
            if (this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined') {
                if (localStorage.getItem('Recurrentpayment') && localStorage.getItem('Recurrentpayment').toString() == 'true') {
                    this.saveRecurentpay()
                } else {
                    this.payement_end(this.$store.state.devispayement.devis);
                }
            }
        },

        /*== Save recurent payment for Sunu EducationPlus ==*/
        saveRecurentpay() {
            const item = JSON.parse(localStorage.getItem('ReccurentPayItem'))
            let numcommande = (this.$store.state.devispayement.numero_police).replace(/[/]/g, '_');

            const data = {
                userid: store.state.user._id,
                numero: item.numero_police,
                partenaireid: item.partenaireid._id,
                brancheid: item.brancheid._id,
                contratid: item._id,
            }

            axios.get('https://orab.assuraf.com/response.php/' + numcommande)
                .then(res => {
                    if (res.data.status == "SUCCESS") {
                        Api().post('recurrentpay/create', data)
                            .then((result) => {
                                this.dialogLoading = false
                                localStorage.removeItem('Recurrentpayment')
                                localStorage.removeItem('ReccurentPayItem')
                                this.dialogLoading = false
                                this.$toasted.show("Votre paiement a été pris en compte ! ", this.ToastTabSucess);
                                setTimeout((() => this.$router.push('/dashboard')), 5000)
                            }).catch((err) => {
                                localStorage.removeItem('Recurrentpayment')
                                localStorage.removeItem('ReccurentPayItem')
                                this.dialogLoading = false
                                this.$toasted.show("Erreur lors du paiement !", this.ToastTabSucess);
                                setTimeout((() => this.$router.push('/dashboard')), 5000)
                            });
                    } else {
                        this.$router.push('/payement/failed')
                    }
                })
                .catch(err => {
                    console.log('Log Orabank', JSON.stringify(err))
                    this.$router.push('/payement/failed')
                })
        },

        sendmailAdmin: function () {
            let amount = localStorage.getItem('amount');
            let numdevis = localStorage.getItem('numdevis');
            const body = {
                sender_email: "Assuraf Logs Orabank",
                sujet: "Paiement de contrat par Orabank ",
                message: "Paiement de " + amount + " FCFA à assuraf.com a bien été validé par \n " + "Nom et Prenom : " + this.$store.state.user.nom + " " + this.$store.state.user.prenom + "\n N° devis : " + numdevis + "\n" + "Date :" + Date()
            };

            Api().post('messaegeadmin/sendMail', body)
                .then(res => {
                    (res)
                })
                .catch(err => {
                    (err)
                })
        },

        //send sms 
        sendsmsclient: function (contrat, branche) {
            let host = '';
            let numcli = this.$store.state.user.telephone_port;
            let adresstosend = numcli.substring(numcli.length - 9);
            if (branche == 'Santé') {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_Sante_' + contrat._id + ".pdf"
            } else {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_' + branche + '_' + contrat._id + ".pdf"
            }
            const orangeToken = process.env.VUE_APP_ORANGE_SMS_TOKEN || '';
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': orangeToken,
            };
            if (orangeToken) {
                axios.defaults.headers.common['Authorization'] = "Bearer " + orangeToken;
            }
            const textclient = {
                outboundSMSMessageRequest: {

                    address: "tel:+221" + adresstosend,
                    senderAddress: "tel:+221772981201",
                    outboundSMSTextMessage: {
                        message: "Assuraf vous informe que votre demande a été bien finalisée et votre attestation est disponible ici " + " " + host
                    },
                }
            };

            axios.post('https://api.orange.com/smsmessaging/v1/outbound/tel:+221772981201/requests', textclient, headers)
                .then(res => {
                    (res)
                })
                .catch(err => {
                    (err)
                })
        },

    },

    mounted() {
        window.scrollTo(0, 0);
        if (this.$store.state.isUserLoggedIn == true) {
            this.Mano = 180;
            this.dialogLoading = true
        } else {
            this.$router.push('/')
        }
    }
}
</script>

<style lang="less" scoped>
p {
    color: #ffa409;
    text-align: center;
}

.title-border {
    border-left: 3px solid #ffa409;
    line-height: 0.5em;
    padding-left: 0.6em;
}

.answer {
    position: relative;
    margin-right: 0;
    float: left;
    display: block;
    margin-right: 2.12766%;
    width: 100%;
}

.highlight {
    padding: 6px 12px;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    font-size: .0625rem;
    cursor: pointer;
    color: #6d6d6d;
    border: solid 1px transparent;
    border-bottom: solid 1px #e9e9e9;
    border-radius: 3px;
    transition: background .4s;
}

.highlight:hover {
    background-color: rgba(255, 164, 9, 0.3);
    padding-left: 10px;
    transition-duration: 0.5s;
}

.age-field {
    cursor: pointer;
    color: #6d6d6d;
    border-bottom: solid 1px #e9e9e9;
    border-radius: 3px;
    transition: background .4s;
}

.text-assuraf {
    color: #ffa409;
}

.container {
    padding: 0px !important;
}

.block-content {
    padding-bottom: 1%;
}

.ligne {
    padding-top: 5px;
    border-bottom: 1px solid grey;
}

.donnee {
    color: #5795b8;
    font-weight: bolder;
    padding: 1%;
}

.garanties-container li {
    display: inline-block;
    padding-right: 7%;

}

/* ============Table recap css======= */
.title-border {
    border-left: 3px solid #ffa409;
    line-height: 0.5em;
    padding-left: 0.6em;
}

.answer {
    position: relative;
    margin-right: 0;
    float: left;
    display: block;
    margin-right: 2.12766%;
    width: 100%;
}

.highlight {
    padding: 6px 12px;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    font-size: .0625rem;
    cursor: pointer;
    color: #6d6d6d;
    border: solid 1px transparent;
    border-bottom: solid 1px #e9e9e9;
    border-radius: 3px;
    transition: background .4s;
}

.highlight:hover {
    background-color: rgba(255, 164, 9, 0.3);
    padding-left: 10px;
    transition-duration: 0.5s;
}

.text-assuraf {
    color: #ffa409;
    font-family: Georgia !important;

}

.type_vehicule li {
    display: inline-block;
}

.garanties-container li {
    border: 0px solid transparent;
}

.table-assuraf {
    background-color: rgba(255, 164, 9, 0.5);
}

.table-simple {
    border: 1px solid #ddd;
}

a {
    text-decoration: none;
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
